import URLS from '../configurations/urls'

class Api {
    static get HTTP_OPTIONS() {
        if (!window.location.origin) { //IE 10 Fix
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }
        return {
            url: "",
            baseURL: `${window.location.origin}${URLS.ARBITER_BASE_PATH}${URLS.ARBITER_API_BASE_PATH}`,
            isEncoded: false,
            isURLSameOrigin: true
        };
    }

    static get BASE_HTTP_OPTIONS() {
        if (!window.location.origin) { //IE 10 Fix
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }
        return {
            url: "",
            baseURL: `${window.location.origin}${URLS.ARBITER_BASE_PATH}`,
            isEncoded: false,
            isURLSameOrigin: true
        };
    }
}

export default Api;


// WEBPACK FOOTER //
// ./src/api/Api.js